module.exports = __webpack_public_path__ + "static/media/money.85ad5427.jpg";